import styled from 'styled-components';

export const InputWrapper = styled.label`
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  transition: transform ease-in 0.1s;

  &.animated {
    &:active {
      transform: scale(0.9);
    }
  }
`;

export const AnswerLabel = styled.div`
  background: #f5f9ff;
  border-radius: 10px;
  padding: 15px 15px 15px 47px;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #1d201f;
  transition: background-color 0.3s ease-out;

  &.checked {
    background: #177590;
    color: #ffffff;
  }
`;

export const AnswerCheckmark = styled.span`
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
  background: #ffffff;
  border-radius: 50px;
  border: 1px solid #c1c1c1;

  &::after {
    content: '';
    position: absolute;
    display: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ffffff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &.checked::after {
    display: block;
  }

  &.checked {
    border: 2px solid #ffffff;
    background: #177590;
  }
`;
